import { configureStore } from "@reduxjs/toolkit"

import billingReducer from "./billing/slice"
import currentUserReducer from "./currentUser/slice"
import favoritesReducer from "./favorites/slice"
import historyReducer from "./history/slice"
import leaderboardReducer from "./leaderboard/slice"
import meetingProfilesReducer from "./meetingProfiles/slice"
import meetingSessionDetailsReducer from "./meetingSessionDetails/slice"
import participantUsersReducer from "./participantUsers/slice"
import roomFeaturesReducer from "./roomFeatures/slice"
import roomsReducer from "./rooms/slice"
import suggestedReducer from "./suggested/slice"
import upcomingReducer from "./upcoming/slice"
import workspaceReducer from "./workspace/slice"
import workspaceMeetingsReducer from "./workspaceMeetings/slice"

export const store = configureStore({
  reducer: {
    billing: billingReducer,
    currentUser: currentUserReducer,
    favorites: favoritesReducer,
    history: historyReducer,
    leaderboard: leaderboardReducer,
    meetingProfiles: meetingProfilesReducer,
    meetingSessionDetails: meetingSessionDetailsReducer,
    participantUsers: participantUsersReducer,
    rooms: roomsReducer,
    roomFeatures: roomFeaturesReducer,
    suggested: suggestedReducer,
    upcoming: upcomingReducer,
    workspace: workspaceReducer,
    workspaceMeetings: workspaceMeetingsReducer,
  },
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
